import { Form, Input } from "antd";
import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { translation } from "../../../../i18n/translationConstant";
import { LoginSignupFormType } from "../../../../Utils/Constants/loginSignupFormTypes";
import "./index.css";

interface IPinInputComponentProps {
  onChange?: (event: string) => void;
  className?: string;
  label?: string;
  id?: string;
  enterPressed?: () => void;
  nameField?: string;
  customRule?: any;
  addonBefore?: ReactNode;
  maxLength?: number;
}

const PinInputComponent: React.FC<IPinInputComponentProps> = ({
  className,
  label,
  id,
  enterPressed,
  onChange,
  nameField,
  customRule,
  addonBefore,
  maxLength,
}) => {
  const { t } = useTranslation();
  const onPasswordChange = (e: any) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/gi, "");
  };
  return (
    <Form.Item
      className={`${className} formItemMarginBotton`}
      name={nameField ? nameField : LoginSignupFormType.pin}
      rules={[
        {
          required: true,
          message: t(translation.errorEnterPin),
        },
        {
          len: 6,
          message: t(translation.errorPinLength),
        },
        {
          validator: customRule,
        },
      ]}
    >
      <Input.Password
        addonBefore={addonBefore}
        type="password"
        autoComplete="off"
        id={id}
        inputMode="text"
        maxLength={maxLength ? maxLength : 6}
        placeholder={label ? label : t(translation.lblEnterPin)}
        onPressEnter={enterPressed}
        onInput={onPasswordChange}
        onChange={(event: any) => onChange && onChange(event.target.value)}
        className="formItemPinInput"
      />
    </Form.Item>
  );
};

export default PinInputComponent;
